import React from "react";
import { BsCalendar2Minus, BsPinMapFill } from "react-icons/bs";

export default function Lead(props) {
    const { setIsForm } = props;

    return (
        <section className="py-3">
            <div className="container">
                <div className="row justify-content-between text-justify">
                    <div className="col-md-8">
                        <div className="mb-4">
                            <h1 className="">CyberSecGO 2024</h1>
                            <div className="d-flex align-center mb-1">
                                <BsCalendar2Minus size={18} className="mr-2" />
                                <h6 className="mb-0">23 e 24 de agosto de 2024</h6>
                            </div>
                            <div className="d-flex align-center mb-1">
                                <BsPinMapFill size={18} className="mr-2" />
                                <h6 className="mb-0">K Hotel - Av. Deputado Jamel Cecílio, nº 2550,<br /> Jardim Goiás, 74810-100 Goiânia - GO</h6>
                            </div>
                        </div>
                        <div>
                            <h4 className="mb-1">Sobre o evento</h4>
                            <p>A equipe do CybsersecGO reuniu renomados palestrantes e especialistas em cibersegurança para compartilhar insights e estratégias inovadoras.</p>
                            <p>O evento em Goiânia oferece acesso às últimas tendências em ameaças cibernéticas, soluções e uma visão abrangente do cenário atual, eliminando a necessidade de deslocamento para outras cidades. Participe desta experiência única, unindo excelência e vanguarda tecnológica para construir um futuro digital mais seguro em Goiânia. CybsersecGO redefine o padrão em cibersegurança, proporcionando um evento de classe mundial na cidade.</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">

                            <div className="col-12 card px-2 py-2 mb-1 text-center">
                                <div className="row">
                                    <div className="col-12">
                                        <h6 className="d-inline">Primeiro Lote{" "}</h6>
                                        <p className="d-inline text-cut"><small>até 30/05</small></p>
                                    </div>
                                    <div className="col-12 text-break d-inline mb-2">
                                        <h6 className="d-inline mr-2 text-cut">R$ 599,00</h6><h6 className="d-inline">R$ 399,00</h6>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn-sm btn btn-primary btn-block" onClick={() => setIsForm(true)}>
                                            Comprar ingresso
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 card px-2 py-2 mb-1 text-center">
                                <div className="row">
                                    <div className="col-12">
                                        <h6 className="d-inline">Segundo Lote</h6>
                                        <p className="d-inline text-cut"><small>até 30/06</small></p>
                                    </div>
                                    <div className="col-12 text-break d-inline mb-2">
                                        <h6 className="d-inline mr-2 text-cut">R$ 599,00</h6><h6 className="d-inline">R$ 499,00</h6>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn-sm btn btn-secondary btn-block" disabled>
                                            Em breve
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 card px-2 py-2 mb-1 text-center">
                                <div className="row">
                                    <div className="col-12">
                                        <h6 className="d-inline">Terceiro Lote</h6>
                                    </div>
                                    <div className="col-12 text-break d-inline mb-2">
                                        <h6 className="d-inline">R$ 599,00</h6>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn-sm btn btn-secondary btn-block" disabled>
                                            Em breve
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
